import Vue from 'vue'
import axios from 'axios'

const state = {
  isFetching: false,
  isMore: true,
  experience: null,
  experiences: null,
  experiencePhotos: null,
  experienceReviews: null,
  experienceQty: null,
  pageCount: null
}

const actions = {
  LOAD_EXPERIENCE_LIST: ({commit}, queryData) => {
    const url = 'experiences'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_EXPERIENCE_LIST', response.experiences)
        } else {
          commit('SET_EXPERIENCE_LIST', null)
        }
        commit('SET_EXPERIENCE_QTY', response.exp_qty)
        commit('SET_PAGE_COUNT', response.page_count)
      })
  },
  LOAD_EXPERIENCE_DETAIL: async ({commit}, id) => {
    commit('SET_EXPERIENCE_DETAIL', null)
    const url = `experiences/${id}`
    const {data} = await axios.get(url)
    if (!data.error) {
      commit('SET_EXPERIENCE_DETAIL', data)
    }
  },
  LOAD_EXPERIENCE_REVIEWS: ({commit}, queryData) => {
    const url = 'experiences/' + queryData.id + '/reviews'
    Vue.http.get(url, {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          if (queryData.page > 0) {
            commit('ADD_EXPERIENCE_REVIEWS', response.reviews)
          } else {
            commit('SET_EXPERIENCE_REVIEWS', response.reviews)
          }
          commit('SET_IS_MORE', true)
          if (response.reviews.length < queryData.limit) {
            commit('SET_IS_MORE', false)
          }
        } else {
          commit('SET_IS_MORE', false)
        }
      })
  }
}

const mutations = {
  SET_EXPERIENCE_LIST: (state, experiences) => {
    state.experiences = experiences
  },
  SET_EXPERIENCE_QTY: (state, experienceQty) => {
    state.experienceQty = experienceQty
  },
  SET_PAGE_COUNT: (state, pageCount) => {
    state.pageCount = pageCount
  },
  SET_EXPERIENCE_DETAIL: (state, experience) => {
    state.experience = experience
  },
  SET_EXPERIENCE_PHOTOS: (state, experiencePhotos) => {
    state.experiencePhotos = experiencePhotos
  },
  SET_EXPERIENCE_REVIEWS: (state, experienceReviews) => {
    state.experienceReviews = experienceReviews
  },
  ADD_EXPERIENCE_REVIEWS: (state, experienceReviews) => {
    state.isFetching = false
    state.isMore = true
    state.experienceReviews.push(...experienceReviews)
  },
  UPDATE_TRANSLATED_REVIEW: (state, data) => {
    const index = data.index
    state.experienceReviews[index].display_type = data.display_type
    if (data.translated_comment) {
      state.experienceReviews[index].translated_comment = data.translated_comment
    }
    if (data.translated_reply_comment) {
      state.experienceReviews[index].translated_reply_comment = data.translated_reply_comment
    }
    state.experienceReviews = [...state.experienceReviews]
  },
  UPDATE_FAVORITE_EXPERIENCE: (state, status) => {
    state.experience.is_favorited_experience = status
  },
  SET_IS_MORE: (state, status) => {
    state.isMore = status
  }
}

const getters = {
  getState: state => {
    return state
  },
  getExperience: state => {
    return state.experience
  },
  getExperiences: state => {
    return state.experiences
  },
  getExperienceReviews: state => {
    return state.experienceReviews
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more_reviews'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/experience.js